import { TabConfigType } from '@common';
import { ArtistDetailsEndKey } from 'src/i18next';

type ArtistTab = TabConfigType<'general' | 'shows' | 'finance'> & {
  labelKey: ArtistDetailsEndKey<'TABS'>;
};

export const tabs: ArtistTab[] = [
  {
    labelKey: 'GENERAL',
    value: 'general',
    requiredPermissions: [],
  },
  {
    labelKey: 'SHOWS',
    value: 'shows',
    requiredPermissions: [],
  },
  {
    labelKey: 'FINANCE',
    value: 'finance',
    requiredPermissions: [
      {
        permission: 'FINANCE',
        action: 'READ',
      },
    ],
  },
];
